import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { NotificationTypeEnum } from 'src/app/shared/enum/NotificationTypeEnum';
import { DateAsAgoPipe } from 'src/app/shared/pipes/date-as-ago.pipe';

@Component({
    standalone: true,
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        DateAsAgoPipe,
        MatProgressBarModule
    ]
})
export class NotificationComponent {

    @Input() notifications: any[];
    @Output() closeNotification: EventEmitter<boolean> = new EventEmitter();
    showNotifications: boolean = false;
    notificationTypeEnum = NotificationTypeEnum;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(private request: DoHttpService,
        private breakpointObserver: BreakpointObserver) { }

    closeNotificationFn() {
        this.showNotifications = false;
        this.closeNotification.emit(true);
    }

    removeNotification(id) {
        const putUrl = this.request.realTimeBaseUrl + 'api/remove-notification/' + id;
        this.request.put(putUrl, false, null).subscribe();
    }

    removeAllNotifications() {
        const putUrl = this.request.realTimeBaseUrl + 'api/remove-notifications';
        this.request.put(putUrl, false, null).subscribe();
    }

    getIcon(type: NotificationTypeEnum): string {
        switch (type) {
            case NotificationTypeEnum.GenerationRequestSuccess:
            case NotificationTypeEnum.ComponentUploadCompleted:
                return 'check_circle';
            case NotificationTypeEnum.GenerationRequestFailed:
                return 'error';
            case NotificationTypeEnum.GenerationRequestSubmited:
            case NotificationTypeEnum.ComponentUploadStarted:
                return 'pending';
            case NotificationTypeEnum.SupportRequestCreated:
                return 'support_agent';
            case NotificationTypeEnum.SupportRequestUpdated:
                return 'update';
            default:
                return 'notifications';
        }
    }

    getIconClass(type: NotificationTypeEnum): string {
        switch (type) {
            case NotificationTypeEnum.GenerationRequestSuccess:
            case NotificationTypeEnum.ComponentUploadCompleted:
                return 'icon--success';
            case NotificationTypeEnum.GenerationRequestFailed:
                return 'icon--danger';
            case NotificationTypeEnum.GenerationRequestSubmited:
            case NotificationTypeEnum.ComponentUploadStarted:
                return 'icon--primary';
            case NotificationTypeEnum.SupportRequestCreated:
                return 'icon--info';
            case NotificationTypeEnum.SupportRequestUpdated:
                return 'icon--warning';
            default:
                return 'icon--default';
        }
    }

    getItemClass(type: NotificationTypeEnum): string {
        switch (type) {
            case NotificationTypeEnum.GenerationRequestSuccess:
            case NotificationTypeEnum.ComponentUploadCompleted:
                return 'notif-item--success';
            case NotificationTypeEnum.GenerationRequestFailed:
                return 'icon--danger';
            case NotificationTypeEnum.GenerationRequestSubmited:
            case NotificationTypeEnum.ComponentUploadStarted:
                return 'notif-item--primary';
            case NotificationTypeEnum.SupportRequestUpdated:
                return 'notif-item--warning';
            default:
                return '';
        }
    }
}
